import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ExpandMore } from "@mui/icons-material";
import { useWatch } from "react-hook-form";
import React from "react";
import { useRecoilState } from "recoil";
import AssetUploader from "./_components/AssetUploader";
import { accordionExpandedState } from "../../recoil";
import {IFormValues, substitutionReasonValue} from "../../types";

const Assets = () => {
    const { t } = useTranslation('booking');
    const [assetsExpanded, setAssetsExpanded] = useRecoilState(accordionExpandedState('assets'));
    const reason = useWatch<IFormValues, "eventInfo.reason">({
        name: 'eventInfo.reason'
    });
    const viewModuloCai = [substitutionReasonValue.INCIDENTE_CON_CONTROPARTE, substitutionReasonValue.INCIDENTE_SENZA_CONTROPARTE, substitutionReasonValue.FURTO_PARZIALE, substitutionReasonValue.INCENDIO].includes(reason);
    const viewDenunciaFurtoSmarrimento = [substitutionReasonValue.FURTO_VEICOLO, substitutionReasonValue.FURTO_PARZIALE, substitutionReasonValue.TARGA_SMARRITA].includes(reason);
    const isRequiredDenunciaFurtoSmarrimento = [substitutionReasonValue.FURTO_VEICOLO].includes(reason);
    const viewAssetAccordion = ![substitutionReasonValue.REMARKETING, substitutionReasonValue.CAMBIO_TARGA].includes(reason);
    const viewRicevutaCarroattrezzi = ![substitutionReasonValue.FURTO_VEICOLO].includes(reason);

    return(
        <>
            {(viewModuloCai || viewDenunciaFurtoSmarrimento || viewRicevutaCarroattrezzi) && viewAssetAccordion &&
            <Accordion expanded={assetsExpanded} onChange={(e, expanded) => setAssetsExpanded(expanded)}>
                <AccordionSummary expandIcon={<ExpandMore/>}
                                  sx={{
                                      '.MuiAccordionSummary-content': {
                                          justifyContent: "space-between",
                                          alignItems: "center"
                                      }
                                  }}
                >
                    <Typography variant="h5">
                        {t('label.attachments')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item container  columnSpacing={3}>
                        {viewModuloCai &&
                        <Grid item xs={12} mb={4}>
                            <AssetUploader
                                field={'caiModuloDenuncia'}
                                label={t('label.assets_modulo_cai')}
                            />
                        </Grid>
                        }
                        {viewDenunciaFurtoSmarrimento &&
                        <Grid item xs={12} mb={4}>
                            <AssetUploader
                                field={'denunciaFurtoSmarrimento'}
                                label={t('label.assets_denuncia_furto_smarrimento')}
                                required={isRequiredDenunciaFurtoSmarrimento}
                            />
                        </Grid>
                        }
                        {viewRicevutaCarroattrezzi &&
                        <Grid item xs={12} mb={4}>
                            <AssetUploader
                                field={'ricevutaCarroattrezzi'}
                                label={t('label.assets_ricevuta_carroattrezzi')}
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
            }
            </>
    );
}

export default Assets;
